class MobileCarousel {
    constructor(containerId, options = {}) {
      this.scrollContainer = document.getElementById(containerId);
      this.textContent = document.getElementById(options.textContentId || 'mobile-text-content');
      this.dots = document.querySelectorAll('.dot');
      this.slideContent = options.slideContent || [];
      
      this.currentIndex = 0;
      this.isTransitioning = false;
      
      this.init();
    }
    
    init() {
      if (this.slideContent.length > 0) {
        this.textContent.innerHTML = this.cleanMetafieldContent(this.slideContent[0].content);
      }
      
      this.bindEvents();
    }
    
    cleanMetafieldContent(content) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = content;
      
      const wrapper = tempDiv.querySelector('.metafield-rich_text_field');
      return wrapper ? wrapper.innerHTML : content;
    }
    
    updateContent(index) {
      if (index !== this.currentIndex && !this.isTransitioning && this.slideContent[index]) {
        this.isTransitioning = true;
        
        this.textContent.style.opacity = '0';
        this.textContent.style.transform = 'translateY(20px)';
        
        setTimeout(() => {
          this.textContent.innerHTML = this.cleanMetafieldContent(this.slideContent[index].content);
          this.currentIndex = index;
          
          this.textContent.style.transform = 'translateY(-20px)';
          
          requestAnimationFrame(() => {
            this.textContent.style.opacity = '1';
            this.textContent.style.transform = 'translateY(0)';
            
            setTimeout(() => {
              this.isTransitioning = false;
            }, 300);
          });
        }, 150);
        
        this.updateDots(index);
      }
    }
    
    updateDots(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('opacity-40', i === index);
        dot.classList.toggle('opacity-100', i !== index);
      });
    }
    
    bindEvents() {
      this.scrollContainer.addEventListener('scroll', () => {
        const scrollLeft = this.scrollContainer.scrollLeft;
        const containerWidth = this.scrollContainer.clientWidth;
        const scrollWidth = this.scrollContainer.scrollWidth;
        const itemWidth = window.innerWidth * 0.65 + 4; // 65vw + gap
        
        if (scrollLeft + containerWidth >= scrollWidth - 50) {
          this.updateContent(this.slideContent.length - 1);
          return;
        }
        
        const newIndex = Math.floor((scrollLeft + itemWidth / 2) / itemWidth);
        
        if (newIndex >= 0 && newIndex < this.slideContent.length) {
          this.updateContent(newIndex);
        }
      });
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const itemWidth = window.innerWidth * 0.65 + 4;
          this.scrollContainer.scrollTo({
            left: index * itemWidth,
            behavior: 'smooth'
          });
          this.updateContent(index);
        });
      });
    }
  }